(ns client-portal.client.products.google-cloud-projects.data
  (:require [client-portal.client.ai-agent.chat.data :as chat.d]
            [client-portal.client.products.data :as products.d]
            [client-portal.client.reports.individual.data :as reports.d]
            [shared.core.account.data :as account.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]))

(def product-labels
  {"oasys" "OASYS"
   "voice-commerce" "Voice Commerce"})

(defn- route-products
  "The products the current page shows data for: a product's own pages, the saved report being viewed, or the report
   the builder is editing (its authored components plus the product it authors against)"
  [db]
  (let [route-name (router/current-route-name db)]
    (cond
      (contains? chat.d/report-builder-routes route-name)
      (->> (tree-seq coll? seq (chat.d/report-configuration db))
           (filter map?)
           (keep #(or (get % "product") (get % "domain")))
           (cons (chat.d/report-product db))
           (set))

      :else
      (if-let [report-id (reports.d/current-report-id db)]
        (set (get-in db (conj reports.d/by-id-path report-id :products)))
        (case (or (some-> route-name (namespace))
                  (some-> route-name (name)))
          "oasys" #{"oasys"}
          "vc" #{"voice-commerce"}
          #{})))))

(defn google-cloud-project-overrides
  "The page's products with a Google Cloud project override, as [{:reference-id :label :project-id} ..].
   Admins only, since the server ignores the overrides for anyone else."
  [db]
  (when (account.d/has-every-role? (account.d/account-user-roles db) [account.d/admin-role])
    (let [products (route-products db)
          overrides (products.d/project-params db products)]
      (->> products
           (keep (fn [reference-id]
                   (when-let [project-id (get overrides (products.d/reference-id->project-param reference-id))]
                     {:reference-id reference-id
                      :label (product-labels reference-id)
                      :project-id project-id})))
           (sort-by :label)
           (vec)))))

(re/reg-sub :products/google-cloud-project-overrides- google-cloud-project-overrides)
